import * as z from "zod/v4";

const SerialReturnMetrics_ = z.object({
  returnVelocity30d: z.number(),
  returnVelocity90d: z.number(),
  lifetimeReturnRate: z.number(),
  totalRefundValue: z.number(),
  totalOrderValue: z.number(),
  greenReturnCount: z.number(),
  returnReasons: z.array(z.string()),
  totalReturns: z.number(),
  totalOrders: z.number(),
  canceledOrderCount: z.number(),
  emailMatchReturnCount: z.number(),
  nameMatchReturnCount: z.number(),
  emailMatchOrderCount: z.number(),
  nameMatchOrderCount: z.number(),
});
export const SerialReturnMetrics: z.ZodType<SerialReturnMetrics> =
  SerialReturnMetrics_;
export interface SerialReturnMetrics
  extends z.infer<typeof SerialReturnMetrics_> {}

const PriceManipulationMetrics_ = z.object({
  customerReturnCount: z.number(),
  returnsWithPositiveAdjustmentCount: z.number(),
  currentReturnAdjustment: z.number(),
  totalPositiveAdjustmentValue: z.number(),
});
export const PriceManipulationMetrics: z.ZodType<PriceManipulationMetrics> =
  PriceManipulationMetrics_;
export interface PriceManipulationMetrics
  extends z.infer<typeof PriceManipulationMetrics_> {}

const TimingExploitationMetrics_ = z.object({
  daysBetweenDeliveryAndReturn: z.number().nullable(),
  returnWindowDays: z.number().nullable(),
  daysUntilPolicyExpiry: z.number().nullable(),
  lastMinuteReturnCount: z.number(),
  totalReturnCount: z.number(),
  returnAndRepurchaseSameSkuCount: z.number(),
  averageDaysToReturnFiling: z.number().nullable(),
});
export const TimingExploitationMetrics: z.ZodType<TimingExploitationMetrics> =
  TimingExploitationMetrics_;
export interface TimingExploitationMetrics
  extends z.infer<typeof TimingExploitationMetrics_> {}

const WardrobingProductInfo_ = z.object({
  productTitle: z.string(),
  variantTitle: z.string(),
  imageUrls: z.array(z.string()),
  reason: z.string().nullable(),
  aiReturnReasonSummary: z.string().nullable(),
  customerInputAnswers: z.array(
    z.object({
      questionText: z.string(),
      answer: z.string().nullable(),
      imageUrl: z.string().nullable(),
    }),
  ),
  greenReturn: z.boolean(),
  damaged: z.boolean(),
  wrongProduct: z.boolean(),
});
export const WardrobingProductInfo: z.ZodType<WardrobingProductInfo> =
  WardrobingProductInfo_;
export interface WardrobingProductInfo
  extends z.infer<typeof WardrobingProductInfo_> {}

const WardrobingMetrics_ = z.object({
  daysBetweenDeliveryAndReturn: z.number().nullable(),
  returnReasonIsVague: z.boolean(),
  returnReasonText: z.string(),
  itemTotalValue: z.number(),
  hasHighValueItems: z.boolean(),
  greenReturnCount90d: z.number(),
  customerReturnRateForCategory: z.number().nullable(),
  totalReturns: z.number(),
  isGreenReturn: z.boolean(),
  products: z.array(WardrobingProductInfo),
});
export const WardrobingMetrics: z.ZodType<WardrobingMetrics> =
  WardrobingMetrics_;
export interface WardrobingMetrics extends z.infer<typeof WardrobingMetrics_> {}

const FtidMetrics_ = z.object({
  orderDeliveryAddress: z.string().nullable(),
  customerReturnFromAddress: z.string().nullable(),
  warehouseAddress: z.string().nullable(),
  isManualLabel: z.boolean(),
  returnTotalValue: z.number(),
  daysBetweenDeliveryAndReturn: z.number().nullable(),
  previousNonReceiptClaims: z.number(),
  hasCarrierClaim: z.boolean(),
  isRedoExchange: z.boolean(),
  isPosOrder: z.boolean(),
});
export const FtidMetrics: z.ZodType<FtidMetrics> = FtidMetrics_;
export interface FtidMetrics extends z.infer<typeof FtidMetrics_> {}

const FraudDetectionInput_ = z.object({
  serialReturn: SerialReturnMetrics,
  priceManipulation: PriceManipulationMetrics,
  timingExploitation: TimingExploitationMetrics,
  wardrobing: WardrobingMetrics,
  ftid: FtidMetrics,
  matchedByCustomerName: z.boolean(),
  collectedAt: z.coerce.date(),
});
export const FraudDetectionInput: z.ZodType<FraudDetectionInput> =
  FraudDetectionInput_;
export interface FraudDetectionInput
  extends z.infer<typeof FraudDetectionInput_> {}
